var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5657 14L12.86 17.7583C12.5937 18.0264 12.4444 18.3921 12.4444 18.7732V24.6858L10.5556 23.7283V18.7732C10.5555 18.5845 10.5188 18.3977 10.4475 18.2233C10.3762 18.049 10.2717 17.8907 10.14 17.7573L4.88889 12.4336V10.915H14V9H4.41667C4.04094 9 3.68061 9.15132 3.41493 9.42067C3.14926 9.69002 3 10.0553 3 10.4363V12.4336C3.00011 12.9415 3.19918 13.4285 3.55344 13.7875L8.66667 18.9714V24.1726C8.66667 24.3949 8.72773 24.6127 8.843 24.8018C8.95826 24.9909 9.12318 25.1437 9.31928 25.2431L12.8298 27.0221C12.9882 27.1024 13.1642 27.1403 13.3411 27.1323C13.5181 27.1242 13.69 27.0704 13.8407 26.976C13.9913 26.8816 14.1157 26.7497 14.2019 26.5929C14.2881 26.4361 14.3334 26.2595 14.3333 26.0799V18.9714L19.237 14H16.5657Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4L16 12",
    stroke: "#898F96",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L24 12",
    stroke: "#898F96",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilterIcon);
export default __webpack_public_path__ + "static/media/clearFilterIcon.b4218c7c5ffafc934d7df4ec7df97f51.svg";
export { ForwardRef as ReactComponent };